<template>
    <v-container>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title class="text-uppercase justify-center">{{ metaData.header }}</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="py-4">
                        <product-form
                            :initial="formInitialData"
                            :page="'copy'"
                            @remove-image="removeImage"
                            @validated="onValidated"
                        ></product-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <snack-general
            :snack-data="snackData"
        ></snack-general>
        <load-overlay :overlay="overlay"></load-overlay>
    </v-container>
</template>

<script>
import LoadOverlay from "../../../components/overlays/LoadOverlay";
import ProductForm from "../../../components/forms/ProductForm";
import SnackGeneral from "../../../components/snacks/SnackGeneral";
import { MixinAppSnack, MixinProductForm } from "../../../mixins";
import { ProductsService } from "../../../services";

export default {
    name: "ProductCopy",
    components: { LoadOverlay, ProductForm, SnackGeneral },
    mixins: [ MixinAppSnack, MixinProductForm ],
    props: ['id'],
    data() {
        return {
            metaUrl: '/products/copy-product',
            overlay: false,
        }
    },
     methods: {
         createProduct(data) {
             this.overlay = true
             ProductsService.setAuth(this.$store.getters.token);
             ProductsService.create(this.getFormData(data))
                 .then(() => {
                     this.snackHandle(this.$t('yourProductSaved'), 'main--black', true);
                     this.resetSnack();
                     this.setSuccessSnack();
                     this.setSnackText(this.$t('addProductSuccess'));
                     this.openSnack();
                     setTimeout(() => {
                         this.$router.push({ name: 'Products.List' })
                     },4000)
                 })
                 .catch(err => {
                     const errData = err.response.data;
                     if(errData.error && errData.error.includes('Sending message error')) {
                         this.snackHandle(`${this.$t('addProductSuccess')} ${this.$t('sendMessageError')}` , 'warning', true);
                         setTimeout(() => {
                             this.overlay = false;
                             this.$router.push({ name: 'Products.List' })
                         },4000);
                     } else {
                         this.snackHandle(this.$t('changesSavedError') , 'error', true);
                         this.overlay = false;
                     }
                     console.log(err);
                 });
         },
         onValidated(data) {
             this.createProduct(data);
         },
    },
    created() {
        this.setInitial();
    },
}
</script>

<style scoped>

</style>
